import basic from './basic';

const rootTheme = {
  basic,
};

export default rootTheme;
